/**
=========================================================
* IDP React - v2.2.0
=========================================================
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
// IDP React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// IDP React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import documentsTableData from "layouts/documents/data/documentsTableData";

function Documents() {
  const { columns, rows } = documentsTableData();

  const handleUpload = () => {
    // TODO: Implement file upload
    console.log("Upload document");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Documents List
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={{
                    defaultValue: 10,
                    entries: [5, 10, 25, 50],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                />
                <MDBox display="flex" justifyContent="flex-end" mt={2} pb={3} pr={2}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={handleUpload}
                    startIcon={<Icon>upload</Icon>}
                  >
                    Upload
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Documents;
